import React, { useState } from "react";
import { makeStyles } from "@material-ui/styles";
import Grid from "@material-ui/core/Grid";
import PubItem from "./PubItem";
import styles from "./styles";

import Map from "../CgbFindPubResultsBlock/Map";
const useStyles = makeStyles((theme) => styles(theme));

export default function UnifiedListing({ pubs = [], data = {} }) {
  const classes = useStyles();

  pubs.map((pub) => {
    pub.PubData.url_featured_image = pub.PubData.featuredImage;
    pub.PubData.id = pub.PubData.crmId;
  });

  const map = (
    <Map
      pubs={pubs}
      firstPub={pubs[0]}
      className={classes.Map}
      showAll={true}
    />
  );

  const [display, setDisplay] = useState("list");
  const showList = function() {
    setDisplay("list");
  };

  const showMap = function() {
    setDisplay("map");
  };

  return (
    <div className={classes.results}>
      <div className="list-filter">
        <span
          onClick={showList}
          className="grid"
          data-active={display === "list"}
        >
          Grid View
        </span>
        <span onClick={showMap} className="map" data-active={display === "map"}>
          Map View
        </span>
      </div>
      {display === "list" && (
        <div className={classes.grid}>
          <Grid container spacing={2} direction="row">
            {pubs.map((pub, index) => {
              return (
                <PubItem
                  key={`pubitem-${index}`}
                  classes={classes}
                  pub={pub.PubData}
                />
              );
            })}
          </Grid>
        </div>
      )}
      {display === "map" && (
        <div className={classes.map} style={{ width: "100%" }}>
          {map}
        </div>
      )}
    </div>
  );
}
